import { Avatar, ShareStatus } from "@/components/common";
import { money } from "@/lib/api";

const SHADES = ["bg-primary", "bg-[#15A87A]", "bg-[#0F7A5A]", "bg-[#0B5C44]", "bg-[#2FE0A6]/70", "bg-[#0A4434]"];

export const AllocationBar = ({ entries }) => {
  const parts = entries.filter((e) => (e.percent || 0) > 0);
  return (
    <div className="flex h-10 w-full overflow-hidden rounded-lg border border-border bg-secondary" data-testid="allocation-bar" role="img"
      aria-label={parts.map((p) => `${p.user.name} ${p.percent}%`).join(", ") || "Nothing allocated"}>
      {parts.map((p, i) => (
        <div key={i} className={`${SHADES[i % SHADES.length]} flex items-center justify-center text-xs font-semibold text-primary-foreground transition-[width] duration-500`} style={{ width: `${Math.min(p.percent, 100)}%` }}>
          {p.percent >= 8 ? `${p.percent}%` : ""}
        </div>
      ))}
    </div>
  );
};

export const ContributionTable = ({ plan, sample = false }) => (
  <div data-testid="contribution-table">
    <div className="hidden grid-cols-[1.4fr_1fr_auto] gap-4 border-b border-border pb-3 sm:grid">
      <span className="eyebrow text-[10px]">Co-host</span><span className="eyebrow text-[10px]">Proposed share</span><span className="eyebrow w-28 text-[10px]">Status</span>
    </div>
    <ul className="divide-y divide-border">
      {plan.entries.map((e, i) => (
        <li key={e.user.id || i} className="grid grid-cols-[1fr_auto] items-center gap-x-4 gap-y-2 py-4 sm:grid-cols-[1.4fr_1fr_auto]" data-testid={`contribution-row-${i}`}>
          <div className="flex items-center gap-4">
            <Avatar person={e.user} size={56} className="rounded-lg" />
            <div>
              <p className="font-display text-2xl leading-tight">{e.user.name}</p>
              <p className="text-xs text-muted-foreground">{e.role === "lead" ? "Lead host" : "Co-host"}</p>
            </div>
          </div>
          <div className="col-start-1 row-start-2 sm:col-start-2 sm:row-start-1">
            <p className="font-display text-3xl" data-testid={`contribution-percent-${i}`}>{e.percent != null ? `${e.percent}%` : "—"}</p>
            {e.amount != null && <p className="text-sm text-muted-foreground" data-testid={`contribution-amount-${i}`}>{money(e.amount, plan.currency)}</p>}
          </div>
          <div className="col-start-2 row-span-2 row-start-1 justify-self-end sm:col-start-3 sm:row-span-1 sm:w-28">
            <ShareStatus status={e.status} testId={`contribution-status-${i}`} />
          </div>
        </li>
      ))}
    </ul>
    <div className="mt-4 space-y-3">
      <AllocationBar entries={plan.entries} />
      <p className="text-lg" data-testid="allocation-summary">
        {plan.allocated_percent}% allocated{plan.budget_total ? ` · ${money(plan.allocated_amount, plan.currency)} of ${money(plan.budget_total, plan.currency)}` : ""}
      </p>
      <p className="text-sm text-muted-foreground">{sample ? "Illustrative planning example. Names and shares are sample data." : "Every co-host confirms their own contribution before the plan is agreed."}</p>
    </div>
  </div>
);
